/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unused-imports/no-unused-vars */
import { useState } from "react";

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import listPlugin from "@fullcalendar/list";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import timelinePlugin from "@fullcalendar/timeline";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";

import "./calendar.scss";

// import "@fullcalendar/core/main.css";
// import "@fullcalendar/daygrid/main.css";

export const CalendarWrapper = (props: any) => {
  // const calendarComponentRef = React.createRef();

  const [data, setData] = useState(props.data);
  const handleDateClick = (arg: any) => {
    alert(arg.dateStr);
  };


  const handleSelectedDates = (info: any) => {
    alert("selected " + info.startStr + " to " + info.endStr);
    const title = prompt("What's the name of the title");
    if (title != null) {
      const newEvent = {
        title,
        start: info.startStr,
        end: info.endStr,
      };
      const events = [...data.events, newEvent];
      setData({ events: events });
    }
  };

  return (
    <div className="calendar-wrapper">
      <FullCalendar
      eventContent={props?.renderEventContent}
        schedulerLicenseKey="GPL-My-Project-Is-Open-Source"
        // ref={calendarComponentRef}
        initialView="dayGridMonth" // timeGridWeek, listWeek, dayGridWeek, dayGridMonth, resourceTimeline, resourceTimeGridDay, timelineWeek
        // dateClick={handleDateClick}
        droppable={true}
        displayEventTime={true}
        headerToolbar={{
          left: "title",
          right: "prev,next,today",
          // center: "dayGridMonth,timeGridWeek,timeGridDay,listWeek",
        }}
        buttonText={{
          today: 'Today' // Custom label with "T" capitalized
        }}
        selectable={true}
        plugins={[
          dayGridPlugin,
          interactionPlugin,
          timeGridPlugin,
          resourceTimeGridPlugin,
          timelinePlugin,
          listPlugin,
          resourceTimelinePlugin,
        ]}
        eventClick={(event) => {
        }}
        events={data.events}
        select={props?.handleSelectedDates}
        // eventLimit={2}
        dayMaxEvents={2}
        showNonCurrentDates={false}
        height="75vh"
        eventColor={"#" + Math.floor(Math.random() * 16777215).toString(16)}
      />
    </div>
  );
};

export default CalendarWrapper;
